import VacancyCandidatesMathingNotPaid from './VacancyCandidatesMathingNotPaid.component';

export default VacancyCandidatesMathingNotPaid;